import React from 'react';
import { Tooltip } from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { useTranslation } from 'react-i18next';
import useBootstrapSize from '../../hooks/useBootstrapSize';

const defElem = <ErrorOutlineIcon fontSize="small" color="primary" />;

export default function CusItemTooltip({ text, elem = defElem, bgColor = 'background.popover' }) {
  const { isMobile, isLessTablet } = useBootstrapSize();
  const { t } = useTranslation();
  const maxWidth = isMobile ? 300 : isLessTablet ? 600 : 900;

  return (
    <Tooltip
      title={typeof text === 'string' ? t(text) : text}
      slotProps={{
        tooltip: {
          sx: { backgroundColor: bgColor, px: 2, boxShadow: '1px 1px 8px .5px #00000080' }
        },
        popper: {
          sx: {
            '& .MuiTooltip-tooltip': { maxWidth, fontSize: '14px', whiteSpace: 'pre-line' }
          }
        }
      }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', verticalAlign: 'middle' }}>
        {elem}
      </span>
    </Tooltip>
  );
}
